import * as React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import './EditComp.css';


export default function EditComp(props) {
    const {tip, action, edit, float} = props;

    function handleClick(e){
        console.log('>handleClick<')
        if( action)action();
    }

    if( !edit) return;

    if( float === false){
        return(    
            <Tooltip title={tip?tip:"Editar componente"}>
                <IconButton aria-label="edit" color="inherit" onClick={handleClick}>
                    <EditIcon />
                </IconButton>
            </Tooltip>
        )    
    }

    return(
        <div className='edit'>
            <Tooltip title={tip?tip:"Editar componente"}>
                <IconButton aria-label="edit" color="primary" onClick={handleClick}>
                    <EditIcon />
                </IconButton>
            </Tooltip>
        </div>
    )
}